import headerlogo from "../../assets/images/logo.jpg";
import headerlogo2 from "../../assets/images/india_industrial.jpg";
import headerlogo3 from "../../assets/images/pngwing.com (1).png";
import locationimg from "../../assets/images/location.png";
import mirajLogo from "../../assets/images/miraj.png";
import anantaLogo from "../../assets/images/ananta.png";
import ievoLogo from "../../assets/images/ievo.png";
import wonderLogo from "../../assets/images/wonder.png";
import secureLogo from "../../assets/images/secure.png";
import piLogo from "../../assets/images/PI.png";
import wolkemLogo from "../../assets/images/wolkem.png";

const EventCard = ({image,setPreviewImage,formData}) => {
  const imgData = [
    { img: anantaLogo },
    { img: ievoLogo },
    { img: wonderLogo },
    { img: secureLogo },
    { img: piLogo },
    { img: wolkemLogo },
  ];

  return (
    <>
      <div className="flex justify-center">
        <div className="card-main-div">
          <div className="card-header">
            <div className="card-header-content flex items-center justify-between">
              <img className="header-logo" src={headerlogo} alt="img1" />
              <img className="header-logo" src={headerlogo2} alt="img2" />
              <img className="header-logo" src={headerlogo3} alt="img3" />
            </div>
          </div>

          <div className="card-content">
            <div>
              <h2 className="text-md md:text-2xl text-black font-sans font-bold text-center ">
                I Invite You to My Stall At
              </h2>
              <h1 className="text-md md:text-3xl text-white font-sans font-bold text-center mt-2">
                11th INDIA INDUSTRIAL FAIR 2025
              </h1>
            </div>

            <div className="flex justify-center mt-2">
              <div className="">
                <p className="text-sm md:text-lg text-white font-semibold">
                  10th - 13th January 2025
                </p>
              </div>
            </div>

            <div className="flex justify-center mt-2 ">
              <div className="flex">
                <img src={locationimg} alt="location" />
                <p className="text-sm md:text-lg text-white font-semibold">
                  DPS Ground, Bhuwana, Udaipur
                </p>
              </div>
            </div>
           
           <div className="relative">
            <div className="flex justify-center mt-2 md:mt-3">
              <div className="date-div flex gap-4">
              <p className="text-md md:text-lg font-semibold">Dome No. : {formData?.domeNo}</p>
                <p className="text-md md:text-lg font-semibold">Stall No. : {formData?.stallNo}</p>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center">
              <div className="relative mt-4 ">
                {/* <input
                  type="file"
                  accept="image/*"
                  // value={formData?.image}
                  style={{ display: "none" }}
                /> */}
                {image ? (
                  <>
                    <div className="deleteIcon" onClick={()=>setPreviewImage(null)}>
                      ⛌
                    </div>
                    <img
                      className="exhibiting-uploaded-img"
                      src={image}
                      alt="Logo"
                    />
                  </>
                ) : (
                  <label className="">
                    <div className="flex flex-col items-center cursor-pointer exhibiting-img-upload-div ">
                      {/* <input
                        type="file"
                        style={{ display: "none" }}
                        // onChange={handleImageChange}
                      /> */}
                    </div>
                  </label>
                )}
              </div>
              </div>
              <div className="flex justify-center gap-3">
              <div className="company-name-div mt-4">
                <h2 className="text-md md:text-xl font-semibold text-white text-center">
                  {formData?.companyName ? formData?.companyName :"Company Name"}
                </h2>
              </div>
              <div className="company-name-div mt-4">
                <h2 className="text-md md:text-xl font-semibold text-white text-center">
                  {formData?.phone ? formData?.phone :"Mobile Number"}
                </h2>
              </div>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <div className="footer-line"></div>
              <h4 className="text-center text-md md:text-2xl font-semibold mt-2">OUR SPONSORS</h4>
            <div className="flex items-center justify-center gap-3">
                <div className="">
                    <img className="footer-miraj-img" src={mirajLogo} alt="img1" />                    
                </div>
                {
                 imgData?.map((val,ind)=>{
                   return(
                   <div className="" key={ind}>
                    <img className="footer-img" src={val?.img} alt="img1" />                    
                   </div>)
                 })
                }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventCard;
